module.exports = __webpack_public_path__ + "img/qr.1eec8ca3.webp";